export default {
  project: 7, //danh mục CTMTDA
  dictionarySource: 8, //danh mục Nguồn kinh phí
  DictionaryBusiness: 9, //danh mục thu HDSN và DV
  dictionaryFees: 10, //danh mục Phí lệ phí
  dictionaryChapter: 11, //danh mục chương
  dictionaryKind: 12, //danh mục loại khoản
  budgetItem: 13, //danh mục mục - tiểu mục
  dictionaryRevenueBudget: 101, //danh mục thu NSNN
  expenseInvest: 102, // danh mục chi đầu tư
  dictionaryRegular: 103, // danh mục chi thường xuyên
  expenseProjectBefore: 104, // danh mục chi CTMT
  dictionaryPatternRegular: 74,
  dictionaryPresent: 75,
  revenueOther: 106, // thu khác
  //chi khác
  dictionaryExpenseOther: 107,
  //cơ sở tính
  criteria: 77,
};
